import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";

const SEO = ({ description, image, article = false, keywords = [], title }) => {
  const { pathname } = useLocation();
  const siteUrl = "https://www.ilariastumpo.it";
  const defaultDescription = "Ilaria Stumpo - Insegnante di Yoga e Coach del Benessere. Scopri come migliorare il tuo benessere fisico e mentale attraverso lo yoga, la meditazione e uno stile di vita equilibrato.";
  const defaultTitle = "Ilaria Stumpo";
  const defaultImage = `${siteUrl}/favicon/new-logo.png`;
  const defaultKeywords = ["yoga", "benessere olistico", "meditazione", "stile di vita sano", "salute naturale", "yoga terapia", "pranayama", "equilibrio mente-corpo", "yoga in gravidanza", "yoga per principianti", "consapevolezza", ...keywords];

  const currentYear = new Date().getFullYear();

  const seo = {
    title: title,
    description: description || defaultDescription,
    image: image ? `${siteUrl}${image}` : defaultImage,
    url: `${siteUrl}${pathname}`,
  };

  return (
    <Helmet title={seo.title} titleTemplate={`%s | ${defaultTitle}`} htmlAttributes={{ lang: "it" }}>
      {/* Meta tags di base */}
      <meta charSet="utf-8" />
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      <meta name="description" content={seo.description} />
      <meta name="image" content={seo.image} />
      <meta name="keywords" content={defaultKeywords.join(", ")} />
      <meta name="author" content="Ilaria Stumpo" />
      <meta name="robots" content="index, follow" />
      <meta name="revisit-after" content="7 days" />
      <meta name="language" content="Italian" />
      <meta name="copyright" content={`© ${currentYear} Ilaria Stumpo`} />

      {/* Open Graph / Facebook */}
      <meta property="og:locale" content="it_IT" />
      <meta property="og:type" content={article ? "article" : "website"} />
      <meta property="og:title" content={seo.title} />
      <meta property="og:description" content={seo.description} />
      <meta property="og:url" content={seo.url} />
      <meta property="og:site_name" content="Ilaria Stumpo - Insegnante di Yoga & Coach del Benessere" />
      <meta property="og:image" content={seo.image} />
      <meta property="og:image:secure_url" content={seo.image} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:image:alt" content={seo.title} />
      {article && <meta property="article:published_time" content={new Date().toISOString()} />}
      {article && <meta property="article:author" content="Ilaria Stumpo" />}
      <meta property="og:updated_time" content={new Date().toISOString()} />

      {/* Canonical URL */}
      <link rel="canonical" href={seo.url} />

      {/* Favicon e Web App */}
      <link rel="icon" type="image/x-icon" href="/favicon/favicon.ico" />
      <link rel="apple-touch-icon" sizes="180x180" href="/favicon/apple-touch-icon.png" />
      <link rel="icon" type="image/png" sizes="32x32" href="/favicon/favicon-32x32.png" />
      <link rel="icon" type="image/png" sizes="16x16" href="/favicon/favicon-16x16.png" />
      <link rel="manifest" href="/site.webmanifest" />
      <link rel="mask-icon" href="/safari-pinned-tab.svg" color="#5bbad5" />
      <meta name="msapplication-TileColor" content="#da532c" />
      <meta name="theme-color" content="#ffffff" />

      {/* Preconnect e Preload */}
      <link rel="preconnect" href="https://www.google-analytics.com" />
      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin />
      <link rel="dns-prefetch" href="//www.google-analytics.com" />
      <link rel="dns-prefetch" href="//fonts.googleapis.com" />
      <link rel="dns-prefetch" href="//fonts.gstatic.com" />

      {/* Preconnects */}
      <link rel="preconnect" href="https://www.google-analytics.com" />
      <link rel="preconnect" href="https://www.googletagmanager.com" />
    </Helmet>
  );
};

export default SEO;
